var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"animatedNumbers",staticClass:"animated-numbers"},_vm._l((_vm.numbersData),function(ref,i){
var number = ref.number;
var title = ref.title;
return _c('div',{key:i,staticClass:"animated-number"},[_c('span',{staticClass:"number utopia-blk-headline"},[_vm._v(_vm._s(_vm.tweenedValues[i]))]),_c('span',{staticClass:"title slate-bold"},[_vm._v(_vm._s(title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }